import { render, staticRenderFns } from "./GluePricingMatrix.vue?vue&type=template&id=5232d13c&"
import script from "./GluePricingMatrix.vue?vue&type=script&lang=js&"
export * from "./GluePricingMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports